export const ROYAL_FERRIS_THEME = Object.freeze({
  transparent: 'rgba(0,0,0,0)',
  shadow: 0x000000,
  ivory: 0xfffbef,
  pearl: 0xffffff,
  champagne: 0xffe7a3,
  champagneSoft: 0xfff2c6,
  gold: 0xf6c04d,
  goldBright: 0xffdf7a,
  goldDeep: 0xa86505,
  antiqueGold: 0xc88d28,
  royalBronze: 0x7b4a07,
  plumBlack: 0x10051f,
  plumDeep: 0x1a0b35,
  plum: 0x32105f,
  amethyst: 0x8e46d6,
  amethystBright: 0xb56cff,
  sapphireDeep: 0x071329,
  sapphire: 0x123b78,
  sapphireGlow: 0x5fb2ff,
  ruby: 0xb8325d,
  rubyBright: 0xef4f7c,
  emerald: 0x28c987,
  podShell: 0xfffbef,
  podSeat: 0xffedc2,
  podSeatGlow: 0xffffff,
  selectedRing: 0xffdf7a,
  selectedRingInner: 0xffffff,
  badgeFill: 0x8e2f63,
  badgeStroke: 0xffdf7a,
  winnerRing: 0xffdf7a,
  textIvory: '#fff8de',
  textPlum: '#241038',
  textSapphire: '#101a3a',
  textBronze: '#704005',
  textRuby: '#6f1736',
  textMutedGold: '#d8b66d',
  glowRamp: Object.freeze({
    fast: 0x6d5dfb,
    mid: 0xb56cff,
    slow: 0xffdf7a,
    final: 0xfff0b6,
  }),
  sparkles: Object.freeze([0xffdf7a, 0xfff0b6, 0xffffff, 0xb56cff, 0xef4f7c]),
});
